import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CACHE_MANAGER_WRAP, CacheManagerWrapObservable } from '../server/server.tokens';

import { TransferHttpResponse, createHttpResponse, getRequestCacheParams, serializeHttpResponse } from './http.helpers';

/**
 * On server side, the interceptor retrieves cached responses from Node CacheManager based on
 * - HttpContextToken `RESPONSE_CACHE_TTL` for regular Http requests
 * - HttpRequest header `gql-response-cache-ttl` for GraphQL requests
 */
@Injectable()
export class HttpServerCacheInterceptor implements HttpInterceptor {
  constructor(
    @Optional() @Inject(CACHE_MANAGER_WRAP) private readonly wrap$: CacheManagerWrapObservable<TransferHttpResponse>
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const [req, ttl, cacheKey] = getRequestCacheParams(request);
    const next$ = next.handle(req);

    return this.wrap$ && ttl
      ? this.wrap$(
          cacheKey,
          next$.pipe(map(event => (event instanceof HttpResponse ? serializeHttpResponse(event) : null))),
          ttl
        ).pipe(map(data => createHttpResponse(data)))
      : next$;
  }
}
